export class TagModel {
    constructor(public key: string, public value: string) {}
}
